export default __webpack_public_path__ + "static/media/contact.14f9d3c7.svg";